// extracted by mini-css-extract-plugin
export default {"modalContainer":"ht","fadeRight":"it","fadeUp":"jt","topShelf":"kt","newFlavorBadge":"lt","transparentText":"mt","cancelButton":"nt","invisibleLink":"ot","closeIcon":"pt","linkContainer":"qt","hed":"rt","image":"st"};
    if(module.hot) {
      // 1711717530811
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  